<h1 mat-dialog-title >{{data.title}}</h1>
<div class="container">
  <mat-card-content style="width: 70%;margin: auto">
    <form [formGroup]="ingresoForm">

      <div formGroupName="ingreso">
        <div formGroupName="equipoAlmacen" class="row" style="display: flex;flex-wrap: wrap;justify-content: space-between" >

          <mat-form-field appearance="outline" >
            <mat-label>Valoración</mat-label>
            <input matInput placeholder="Valoración" formControlName="valoracion" name="valoracion" required >
          </mat-form-field>
          <mat-form-field appearance="outline" >
            <mat-label>Observaciones</mat-label>
            <input matInput placeholder="Observaciones" formControlName="observaciones" name="observaciones" required >
          </mat-form-field>

          <mat-form-field appearance="outline" >
            <mat-label>Cantidad</mat-label>
            <input matInput placeholder="Cantidad" formControlName="cantidad" name="cantidad" required >
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Costo</mat-label>
            <input matInput placeholder="Costo"formControlName="costo" name="Costo" required>
          </mat-form-field>
        </div>

      </div>



      <mat-dialog-actions align="center">
        <button mat-raised-button mat-dialog-close>Cancelar</button>
        <button mat-raised-button color="primary">{{data.title}}</button>
      </mat-dialog-actions>

    </form>
  </mat-card-content>
</div>
